import { ConfigService } from './providers/config/config.service';
import { HttpService } from './wrappers/Http';
import { StorageService } from './providers/storage.service';
import { UserManagerService } from 'src/app/providers/services/userManager/user-manager.service';
import { AfterViewInit, Component, ComponentFactoryResolver, HostListener, Inject, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ModalService } from './providers/modal-service/ModalService';
import { TranslateService } from '@ngx-translate/core';
import { WebsocketService } from './providers/WebsocketService';
import { SkeletonServiceService } from './components/skeleton-service.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// import { MyAccountComponent } from './pages/my-account/my-account.component';
// import { MessageBoxComponent } from './components/message-box/message-box.component';
import { MyAccountService } from './providers/my-account/my-account.service';
import { BonusAlertComponent } from './components/dialogues/bonus-alert/bonus-alert.component';
import { SampleSlidesResponse } from './mock-data/slides.data';
import { combineLatest, Subscription } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { PartnerBonusService } from './providers/partner-bonus/partner-bonus.service';
import { SystemConfigs } from './utils/utils';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { KycService } from './providers/services/kyc.service';
import { ROUTE_URL } from './enums/route-url.enum';
import { Location } from '@angular/common';
import { redirectMap } from './constants/route-map.constant';
import { VersionService } from './providers/versioning/version.service';

declare var $: any;
let context;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'Sportcash';
  subscription = new Subscription();
  idleInterval: any;
  userIdleTime: any;
  session = undefined;
  id = undefined;
  page = undefined;
  url = window.location.href;
  configLoading = true;
  isAuthentication = true;
  initKycParam = false;
  validateCodeOptions: string[]=[];
  windowScrolled: boolean = false;
  constructor(
    public userManagementService: UserManagerService,
    private router:Router,
    public modalService: ModalService,
    private socketHandler: WebsocketService,
    private storage: StorageService,
    private configsService: ConfigService,
    public uiService: SkeletonServiceService,
    private requestHandler: HttpService,
    private route: ActivatedRoute,
    private accountService: MyAccountService,
    private viewCompRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private partnerBonusService: PartnerBonusService,
    private kycService: KycService,
    private translate: TranslateService,
    private versionService: VersionService,
    private location: Location) {
      this.initializeTheme();
      this.idleLogout();
      // this.configsService.loadConfigs();
      this.subscription.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
        this.scrollToTop();
        let paths = this.router.url.split('/').map((p) => p.split('?')[0]);
        this.isAuthentication = paths.includes('user');
        if(!partnerBonusService.bonusesFetched) {
          const partnerBonusSub = this.partnerBonusService.getPartnerBonuses().pipe(take(1)).subscribe(() => {
              partnerBonusSub.unsubscribe();
          });
          this.subscription.add(partnerBonusSub);
        }
      }));
      context = this;
    }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let rootElement = document.documentElement;
    let scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
    if ((rootElement.scrollTop / scrollTotal ) > 0.2) {
      this.windowScrolled = true;
    } else {
      this.windowScrolled = false;
    }
  }

  scrollToTop() {
    let rootElement = document.documentElement;

    rootElement.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  openPage(){
    let url = "";
    let state: any;
    switch(this.page){
      case "confirmation":
        url = "/user/confirmation";
        state = {validationOpts: this.validateCodeOptions, hideHeader: true};
        break;
      case "fast-signup":
        url = ROUTE_URL.QUICK_SIGNUP;
        break;
      case "signup":
      case "registration":
      case "register":
        url = ROUTE_URL.SIGNUP;
        break;

      default:
        url = this.page;
        break;
    }
    this.router.navigate([url], {state});
  }

  idleLogout() {
    // tslint:disable-next-line: no-shadowed-variable
    const context = this;
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;  // catches touchscreen presses as well
    window.ontouchstart = resetTimer; // catches touchscreen swipes as well
    window.onclick = resetTimer;      // catches touchpad clicks as well
    window.onkeypress = resetTimer;
    window.addEventListener('scroll', resetTimer, true); // improved; see comments
    // function yourFunction() {
    //   // console.log("Executing")
    // }

    function resetTimer() {
      context.userManagementService.lastActiveTime = new Date();
      // clearTimeout(t);
      // t = setTimeout(yourFunction, 10000);  // time is in milliseconds
    }
  }

ngOnInit(){
  const rawPath = window.location.pathname;
  const rawHash = window.location.hash;
  const decodeAndClean = (input: string): string =>
    decodeURIComponent(input).replace(/^\/+/, '').trim();

  const fragment = decodeAndClean(rawHash.replace(/^#\/?/, ''));
  const path = decodeAndClean(rawPath);
  const theme = fragment || path;

  if (redirectMap[theme]) {
    this.router.navigateByUrl(redirectMap[theme]);
  }

  let queryParams =  (new URL(window.location.href)).searchParams.get('initKyc');

  if(queryParams) {
    this.kycService.loadingKYC = true;
  }

  this.subscription.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd), switchMap(() => this.userManagementService.updatePhoneNumber) ).subscribe((update) => {
    if(update.change){
      this.modalService.openNewPhoneNumberingModal(MessageBoxComponent, update.phone).then((res) => {
        if(res.success){
          this.modalService.openDialog('ml_success', res.msg, false, true).then(() => {
            this.userManagementService.onLogIn.next(1);
          });
          if(update.home){
            this.router.navigate(['home']);
          }
        }else {
          this.modalService.openDialog('error', res.msg, false, true).then(() => {
            this.userManagementService.logout().then(() => {
              this.router.navigate([ROUTE_URL.LOGIN]);
            });
          });
        }
        this.userManagementService.updatePhoneNumber.next({change: false, phone: '', home: true});
      });
    }
  }));
  this.subscription.add(this.route.fragment.subscribe(fragment => {
    const pageFragment = fragment ? fragment.replace(/^\/+/, '').trim() : "";
    if(pageFragment.length > 0) {
      this.page = pageFragment;
      this.openPage();
    }

  }
  ));
  const lang = (this.storage.get('lang') || this.translate.getDefaultLang() || this.translate.getBrowserLang()).split('-')[0];
  this.uiService.changeAppLanguage(lang)

  this.userManagementService.getCountryList().then(resp => {
    this.userManagementService.countries.forEach(country => {
      this.userManagementService.dialingCodes.push(country.dialling_code);
    });
    this.userManagementService.dialingCodes.sort();
  });
  this.configsService.$config.subscribe(res => {
    this.userManagementService.loadSlides().then(res => {
      this.userManagementService.bannerSlides = res.slides;
      this.userManagementService.bannerMsg = res.banner;
      $('.carousel').carousel({ interval: 5000, delay: 1500, wrap: true, ride: 'carousel' });
    }).finally(()=> {
      // this.userManagementService.bannerSlides = SampleSlidesResponse.slides;
      // this.userManagementService.bannerMsg = SampleSlidesResponse.banner
    })
    this.getProviders();
    var dataContext = this.url.split('?')[1]
    dataContext = dataContext && dataContext.includes("#/&") ? dataContext.split('#/&')[1] : dataContext;

    if (dataContext) {
      const dataArray = dataContext.split('&')
      let params: any = {}
      dataArray.forEach(data => {
        let keyValue = data.split('=');
        params[keyValue[0]] = keyValue[1]
      })
      // this.userManagementService.setTokenData(params)
      this.page = params['page'];
      if (params['ValidateCode']) {
        this.validateCodeOptions = params['ValidateCode'].split('@').concat(params['lang']);
      }
      if (this.page) {
        this.openPage();
      }

      if(params['initKyc']){
        this.initKycParam = true;
        this.subscription.add(this.userManagementService.sessionUpdated$.subscribe((res) => {
          if(res){
            this.kycService.startKycProcess(this.userManagementService.userData.customer_ID);
          }
        }))
      }

      this.id = { session: params['session'] };
      this.session = params['session'];
      if(params['redirect']){
        this.userManagementService.redirect = decodeURIComponent(params['redirect']);
      }
    }

    if (!this.session && this.storage.checkCookie('session')) {
      this.session = this.storage.getCookie('session');
    }

    let auth = this.storage.getObject('auth', false);
    let user = this.storage.getObject('userData', false);

    if(user) {
      this.userManagementService.userData = user;
      this.socketHandler.connect_session();
    }

    if(auth){
      this.configsService.USER_AUTHORISATION = auth;
    }

    const context = this;
    this.configLoading = true;
    this.requestHandler.get_request(this.configsService.PROXIES.userService , 'system/configs', {}, true).then(response => {

      if ('erc' in response && response.erc == 1) {
        SystemConfigs.forEach(item => {
          if(Object.keys(this.configsService.kycConstraints).includes(item.name)){
            this.configsService.kycConstraints[item.name] = this.getValue_new(item.key, response.data, item.default);
          }else {
            this.configsService[item.name] = this.getValue_new(item.key, response.data, item.default);
          }

        });

        this.configsService.configsLoad$.next(true);
      }

    }).finally(() => {
      this.configLoading = false;
    });
  });
  this.subscription.add(
    combineLatest([
      this.configsService.configsLoad$,
      this.userManagementService.userDataUpdated$
    ]).subscribe(
      ([loaded, updated]) => {
        if(loaded == true || updated == true) {
          if(this.userManagementService.userData){
            this.session = this.userManagementService.userData.session;
          }else if(this.storage.checkCookie('session')) {
            this.session = this.storage.getCookie('session');
          } else if(this.storage.getObject('userData', false)) {
            let user = this.storage.getObject('userData', false);
            this.session = user.session;
          }

          this.authenticateUser().then((result) => {
            if(result){
              this.loadUserDataExtras();
            } else {
              this.router.navigate(['home']);
            }

          });
        }
      }
    ) );
  this.userManagementService.onLogIn.subscribe(res => {
    if (res == 1) {
      this.socketHandler.connect_session();
      const {balances, lang} = this.userManagementService.userData;
      if ('bonusMessage' in balances && !!balances.bonusMessage) {
        this.userManagementService.bonusAvailable.next(1);
        if(!this.kycService.loadingKYC && !this.initKycParam){
          this.openBonusDialog();
        }
      }
      if(lang) {
        this.uiService.changeAppLanguage(lang);
      }
      this.loadUserDataExtras();
    }else {
      this.socketHandler.disconnect();
    }
  })
}
  loadUserDataExtras() {
    this.userManagementService.fetchUserTransactionExtras().then(res => {
      if('erc' in res && res.erc == 1) {
        this.updateData(res.data)
      }
    })
  }

  updateData(data){
    Object.keys(data).forEach(element => {
        this.userManagementService.userData[element] = data[element];
    });
  }

openBonusDialog() {
    const userBalances = this.userManagementService.userData.balances;
    const alertCompFactory = this.componentFactoryResolver.resolveComponentFactory(BonusAlertComponent);
    const alertComponent = this.viewCompRef.createComponent(alertCompFactory);

    alertComponent.instance.bonuses = userBalances.bon;
    alertComponent.instance.bonusMsg = userBalances.bonusMessage;
    alertComponent.instance.close.subscribe((res)=> {
      alertComponent.destroy();
  })
}

clearUrl(){
  if (this.url.includes('?')) {
    this.id = { session: this.url.split('=')[1] };
    this.router.navigate(['home'], {
      queryParams: {
        session: null,
      },
      queryParamsHandling: 'merge'
    });}
}

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {

    this.userManagementService.resetPass.subscribe((res)=>{
      if(res === 1){
        this.forgotenPassword();
          return;
      }
    })

  }

  get loadingKYC() {
    return this.kycService.loadingKYC;
  }
  getProviders() {
    this.userManagementService.validProviders = [];
    this.accountService.getProviders(1).then(data => {
      for (let provider of this.accountService.paymentProviders[1]) {
        if (provider.hasOwnProperty('mask') && provider.mask.trim() != "") {
          let mask = provider.mask.split('#')[0];
          if (mask && mask.split('-').length > 0) {
            for (let item of mask.split('-')) {
              this.userManagementService.validProviders.push(item)
            }
          }
          else if (mask && mask.split('-').length == 1) {
            this.userManagementService.validProviders.push(mask)
          }

        }
      }

    });
  }
  forgotenPassword() {
    this.userManagementService.passModal = true;
    this.modalService.destroy();
    this.router.navigate(['/', 'user', 'forget-password']);

  }

  authenticateUser() {

    if (this.session && this.session.length){
      this.userManagementService.sessionUpdate = true;
      this.userManagementService.sessionUpdated$.next(false);
      return this.userManagementService.authSession(this.session).then(res => {

        if(!this.userManagementService.userData ) {
          this.userManagementService.sessionUpdate = false;
          this.userManagementService.sessionUpdated$.next(true);
          return false;
        }

        let {phone_number} = this.userManagementService.userData;
        let {phoneNumberLength, country_code} = this.configsService;

        if (phone_number && phone_number.length > 0) {
          let phone = phone_number;
          if (phone.startsWith(country_code)) {
            phone = phone.split(country_code)[1];
            if (phone.length < phoneNumberLength) {
              this.configsService.saveUserdata(this.userManagementService.userData);
              this.userManagementService.updatePhoneNumber.next({change: true, phone, home: false});
              // switch (this.page) {
              //   case 'my-account':
              //     const profileRoute = this.uiService.isMobile() ? '/profile/menu' : "/profile"
              //     this.router.navigate([profileRoute]);
              //     break;

              //   default:
              //     break;
              // }
              // this.modalService.openNewPhoneNumberingModal(MessageBoxComponent, phone).then((res) => {
              //   if(res.success){
              //     this.modalService.openDialog('ml_success', res.msg, false, true);
              //   } else {
              //     this.modalService.openDialog('error', res.msg, false, true).then(() => {
              //       this.userManagementService.logout(true);
              //       this.router.navigate(['/user/login']);
              //     });
              //   }
              // });
            }
          }
        }

        if (this.userManagementService.userData) {
              switch (this.page) {
                case 'my-account':
                  const profileRoute = this.uiService.isMobile() ? ROUTE_URL.PROFILE_MENU_MOBILE : ROUTE_URL.PROFILE_PAGE;
                  this.router.navigate([profileRoute]);
                  break;

                default:
                  break;
              }
              // const mobileTab = 7;

              // this.modalService.init(MyAccountComponent, { activeTab: 2, mobileTab }, {});
            }

        this.userManagementService.sessionUpdate = false;
        this.userManagementService.sessionUpdated$.next(true);
        return res;

      });
    } else{
      if (this.userManagementService.redirect) {
        this.openPage();
      }
      this.userManagementService.cleanLocalSession();
      return Promise.reject(false);
    }
  }



  getValue(configs: Array<any>, arg1: string): any {
    let valueToReturn;
    configs.forEach(config => {
      if (config.key === arg1) {
        valueToReturn = config.value;
      }
    });
    return valueToReturn;
  }
  getValue_new(key: string, arr: Array<any>, def:any): any {
    if (!arr.length) return def;
    let returnVal: any;
    try {
      returnVal = arr.find((config) => config.key === key)['value'] || null;
    } catch (error) {
      console.warn(`Couldn't find config parameter ${key}, default as ${def}`, error);
    }
    if(!returnVal) return def;
    switch (typeof def) {
      case 'string':
      case 'object':
        return returnVal;
      case 'number':
        return parseInt(returnVal);
      case 'boolean':
        // return JSON.parse(returnVal);
        return Boolean(JSON.parse(returnVal));
      default:
        return def;
    }
  }
  removeModal() {
    this.modalService.destroy();
    this.userManagementService.passModal = false;
  }
  initializeTheme() {
    const style = document.createElement('style');
    style.innerHTML = `:root { ${
      Object.entries(this.uiService.theme.properties)
        .map(([key, value]) => `${key}: ${value};`)
        .join(' ')
    } }`;
    document.head.appendChild(style);
  }



  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }

}
